import { Outlet } from "react-router-dom";
import SideNavBar from "../../components/SideNavBar/SideNavBar";
import { Box, CssBaseline, Stack } from "@mui/material";

const DefaultNavLayout = () => {
  return (
    <>
      <Stack direction="row" height="100%">
        <CssBaseline />

        <SideNavBar />

        <Box width="100%" p="1rem">
          <Outlet />
        </Box>
      </Stack>
    </>
  );
};

export default DefaultNavLayout;
